import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { getLoginDataHelper } from "_controllers/helpers/getLoginData";

export const useManagerSalesHook = (props) => {
    const history = useNavigate();

    const permission = "MANAGEMENT_REPORTS";
    // const permission = "MARKETING_REPORTS";
    const { userPermissions } = getLoginDataHelper();

    useEffect(() => {
        if (
            typeof userPermissions
                ?.split(",")
                ?.find((element) => element === permission) === "undefined"
        ) {
            history("/");
        }

        return () => {};
    }, []);

    return { permission, userPermissions };
};
